"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEngine = void 0;
var matter_js_1 = require("matter-js");
var matter_js_2 = __importDefault(require("matter-js"));
var GameEngine = /** @class */ (function () {
    function GameEngine(_element, _gameWidth, _gameHeight) {
        this._element = _element;
        this._gameWidth = _gameWidth;
        this._gameHeight = _gameHeight;
        this.frames = 0;
        this.resetBoxTimeoutId = -1;
        this.timeScaleTarget = 1;
        this.engine = matter_js_1.Engine.create();
        this.render = matter_js_1.Render.create({
            element: this._element,
            engine: this.engine,
            options: {
                width: this._gameWidth,
                height: this._gameHeight,
                wireframes: false,
                background: "transparent"
            }
        });
        matter_js_1.Events.on(this.engine, "afterUpdate", this.onAfterEngineUpdate.bind(this));
        var mouse = matter_js_1.Mouse.create(this.render.canvas);
        var mouseConstraint = matter_js_1.MouseConstraint.create(this.engine, {
            mouse: mouse,
            constraint: {
                stiffness: 1,
                render: {
                    visible: false
                }
            }
        });
        this.render.mouse = mouse;
        matter_js_1.World.add(this.engine.world, mouseConstraint);
        matter_js_1.Engine.run(this.engine);
        matter_js_1.Render.run(this.render);
        this.checkBoxesAreWithinGameBounds();
    }
    GameEngine.prototype.onAfterEngineUpdate = function (event) {
        this.engine.timing.timeScale += (this.timeScaleTarget - this.engine.timing.timeScale) * 0.05;
    };
    GameEngine.prototype.slowMotionForSeconds = function (seconds) {
        var _this = this;
        this.timeScaleTarget = 0.01;
        setTimeout(function () { return _this.timeScaleTarget = 1; }, (seconds * 1000));
    };
    GameEngine.prototype.checkBoxesAreWithinGameBounds = function () {
        var _this = this;
        this.frames++;
        var bodies = matter_js_1.Composite.allBodies(this.engine.world);
        if (this.frames % 15 == 0) {
            for (var i = 0; i < bodies.length; i++) {
                var object = bodies[i];
                if (object.isStatic === true) {
                    continue;
                }
                if (object.position.x >= this._gameWidth || object.position.y >= this._gameHeight
                    || object.position.x <= 0 || object.position.y <= 0) {
                    this.onUpdateLostObject(object);
                }
            }
        }
        requestAnimationFrame(function () { return _this.checkBoxesAreWithinGameBounds(); });
    };
    GameEngine.prototype.onUpdateLostObject = function (object) {
        object.render.opacity = 0;
        if (object.isStatic) {
            return;
        }
        matter_js_2.default.Body.setPosition(object, { x: this._gameWidth / 2, y: this._gameHeight / 2 });
        this.resetBoxTimeoutId = setTimeout(function () { return object.render.opacity = 1; }, 1000);
    };
    GameEngine.prototype.addGameObject = function (gameObject) {
        matter_js_1.World.add(this.engine.world, gameObject.object);
    };
    GameEngine.prototype.addMultipleGameObjects = function (gameObjects) {
        var bodies = [];
        for (var i = 0; i < gameObjects.length; i++) {
            var go = gameObjects[i];
            bodies.push(go.object);
        }
        matter_js_1.World.add(this.engine.world, bodies);
    };
    GameEngine.prototype.removeGameObject = function (gameObject) {
        matter_js_1.World.remove(this.engine.world, gameObject.object);
    };
    GameEngine.prototype.removeMultipleGameObjects = function (gameObjects) {
        var bodies = [];
        for (var i = 0; i < gameObjects.length; i++) {
            var go = gameObjects[i];
            bodies.push(go.object);
        }
        matter_js_1.World.remove(this.engine.world, bodies);
    };
    GameEngine.prototype.checkBodiesConnect = function (boxes) {
        var allConnecting = false;
        for (var i = 0; i < boxes.length; i++) {
            var boxA = boxes[i];
            var boxB = boxes[i + 1];
            if (boxB == null) {
                continue;
                // boxB = boxes[i - 1];
            }
            var active = matter_js_2.default.SAT.collides(boxB.object, boxA.object);
            allConnecting = active.collided;
        }
        return allConnecting;
    };
    GameEngine.prototype.destroy = function () {
        if (this.resetBoxTimeoutId !== -1) {
            clearTimeout(this.resetBoxTimeoutId);
        }
    };
    Object.defineProperty(GameEngine.prototype, "bodies", {
        get: function () { return matter_js_1.Composite.allBodies(this.engine.world); },
        enumerable: false,
        configurable: true
    });
    return GameEngine;
}());
exports.GameEngine = GameEngine;
